// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2CZu6","footer":"styles_footer__bE3lU"};